module.exports = __webpack_public_path__ + "img/HC1019-87.553738fc.jpg";